import styled from "styled-components";
import circuitLeft from '../../../../Assets/circuit_left.png'
import circuitright from '../../../../Assets/circuit_right.png'
import logo from '../../../../Assets/bg_logo.png'

export const BgBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const Wrapper = styled.div`
  padding:24px 16px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  position: relative;

  @media (min-width: 768px){
    padding: 32px 64px 32px
   }

  @media (min-width: 1440px) {
    padding: 146px 120px 48px;
  }

  h1{
    font-weight: 700;
    font-size: 32px;
    line-height: 40px;
    letter-spacing: 1px;
    text-align: center;
    font-style: Bold;
    padding-bottom: 10px;

    background: linear-gradient(90deg, var(--color-4C89FF) 20%, var(--color-A6C4FF) 50%, var(--color-d72082)
      80%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    color: transparent;

    @media (min-width: 850px){
      font-size: 56px;
      line-height: 64px;
      letter-spacing: 2px;
      text-align: center;
      max-width: 842px;
      width: 100%;
    }
  }

  p{
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 1px;
    text-align: center;

    .brFirst{
      display: block;
      @media (min-width: 600px){
        display: none;
      }
    }

    .brSecond{
      display: none;
      
      @media (min-width: 945px){
        display: block;
      }
    }

    @media (min-width: 850px){
      font-size: 16px;
      line-height: 24px;
      width: 842px;
      max-width: 842px;
      width: 100%;
    }
  }


  .bg{
    position: absolute;
    height: 100%;
    width: 40%;
    background-repeat:no-repeat;
    background-size: contain;
    background-position: bottom;
    top: 0;
    display: none;

    @media (min-width: 1200px){
      display: block;
    }
  }

  .circuitLeft{
    background-image: url(${circuitLeft});
    left: 0;
  }

  .circuitright{
    background-image: url(${circuitright});
    right: 0;
  }

  .logo{
    background-image: url(${logo});
    width: 100%;
    background-position: top;
    display: none;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    @media (min-width: 1200px){
      display: flex;
    }
  }

  .colors{
    height: 181px;
    width: 181px;
    border-radius: 100%;
    filter: blur(var(--blur, 100px));
    opacity: var(--alpha, 1);
    mix-blend-mode: screen;
    will-change: transform, filter;
  }

  .orbit{
     animation: girar 10s linear infinite;
     display: flex;
     flex-direction: column;
     gap: 50px;
  }

  @keyframes girar {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .blue{
      background-color: #2A73FF80;
    }
    
  .pink{
    background-color: #D7208280;
  }

`;

export const ActionBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 190px;
  min-height: 40px;
  border-radius: 8px;
  border-width: 1px;
  padding: 8px 16px;
  gap: 8px;
  opacity: 1;
  font-weight: 600;
  font-style: bold;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: center;
  background-image: linear-gradient(var(--color-A62AFF), var(--color-A62AFF)),
  linear-gradient(120deg, var(--color-6A9DFF), var(--color-0057FF));
  background-origin: border-box;
  background-clip: padding-box, border-box;
  border: 1px solid transparent;
  z-index:1;

  @media (min-width: 850px){
    width: 269px;
    height: 64px;
  }

  &:hover{
      background-image: linear-gradient(var(--color-3F145E), var(--color-3F145E)),
  linear-gradient(120deg, var(--color-6A9DFF), var(--color-0057FF));
    } 
`

export const nextBtn = styled.button`
  color: var(--color-d72082);
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 55px;
`